<template>
	<App title="Credit">
		<div class="row">
			<div class="col">
				<Block type="data">
					<template #header>
						<h1 class="block-title">Credit - #{{ credit.id }}</h1>
					</template>
					<div class="row">
						<div class="col-8">
							<TextBlock label="User">
								{{ credit.user?.fullname }}
							</TextBlock>
						</div>
						<div class="col">
							<TextBlock label="Partner">
								{{ credit.user?.partner?.name }}
							</TextBlock>
						</div>
					</div>

					<div class="row">
						<div class="col-4">
							<TextBlock label="Amount">
								{{ $render.money(credit.amount) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Penalty Charge">
								{{ $render.money(credit.penalty) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Premium">
								{{ $render.money(credit.premium) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Debt">
								{{ $render.money(credit.debt) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Type" class="text-capitalize">
								{{ credit.type }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Duration"> {{ credit.duration }} months </TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Created">
								{{ $render.date(credit.created_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Due Date">
								{{ $render.date(credit.due_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Completed">
								{{ $render.date(credit.completed_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Pay Date">
								{{ $render.date(credit.payment_at) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Default">
								{{ $render.bool(credit.is_default) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Active">
								{{ $render.bool(credit.active) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Account Bank">
								{{ credit.user.account?.bank }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock :copyable="true" label="Account Number">
								{{ credit.user.account?.number }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Account Name">
								{{ credit.user.account?.name }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Created">
								{{ $render.date(credit.created_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Due Date">
								{{ $render.date(credit.due_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Completed">
								{{ $render.date(credit.completed_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Pay Date">
								{{ $render.date(credit.payment_at) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Proprietor name">
								{{ credit.proprietor.name }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Proprietor Phone">
								{{ credit.proprietor.phone }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Proprietor Email">
								{{ credit.proprietor.email }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Proprietor Business Name">
								{{ credit.proprietor.business }}
							</TextBlock>
						</div>
						<div class="col-8">
							<TextBlock label="Proprietor Business Address">
								{{ credit.proprietor.address }}
							</TextBlock>
						</div>
					</div>
					<template #footer>
						<div class="row">
							<div class="col">
								<button class="btn btn-outline-secondary btn-icon btn-lg me-2" @click="onOpenFinancial"><i class="fas fa-eye"></i> Financial Document</button>
								<button class="btn btn-outline-secondary btn-icon btn-lg" @click="onOpenEmployment"><i class="fas fa-eye"></i> Employment Document</button>
								<button v-show="credit.offer" class="btn btn-outline-secondary btn-icon btn-lg" @click="onOpenOffer"><i class="fas fa-eye"></i> Employment Document</button>
							</div>
						</div>
					</template>
				</Block>
			</div>
		</div>
		<TransactionTable :model="credit" />
	</App>
	<DocumentModal ref="financial-modal" :media="credit.financial" title="Financial Document" />
	<DocumentModal ref="employment-modal" :media="credit.employment" title="Employment Document" />
	<DocumentModal v-if="credit.offer" ref="offer-modal" :media="credit.employment" title="offer Document" />
</template>
<script lang="ts">
import type Credit from '@/models/Credit'
import TransactionTable from '@/pages/snippets/TransactionTable.vue'
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import DocumentModal from '@/vue/components/DocumentModal.vue'
import TextBlock from '@/vue/components/TextBlock.vue'
import App from '@/vue/templates/App.vue'
import { Component, Prop, Ref, Vue, toNative } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		TextBlock,
		Datatable,
		TransactionTable,
		DocumentModal,
	},
})
class Single extends Vue {
	@Prop({ type: Object })
	readonly credit!: Credit

	@Ref('financial-modal')
	readonly financial_modal!: InstanceType<typeof DocumentModal>

	@Ref('employment-modal')
	readonly employment_modal!: InstanceType<typeof DocumentModal>

	@Ref('offer-modal')
	readonly offer_modal!: InstanceType<typeof DocumentModal>

	onOpenFinancial() {
		this.financial_modal.onShow()
	}

	onOpenEmployment() {
		this.employment_modal.onShow()
	}

	onOpenOffer() {
		this.offer_modal.onShow()
	}
}

export default toNative(Single)
</script>
